import { ApiError } from '../lib/api';

interface ErrorBannerProps {
  error: unknown;
  onDismiss?: () => void;
}

/**
 * Renders the server's error message verbatim. The server writes messages
 * that name the fix (CONVENTIONS.md §5, PRD §5.13) — never replace `message`
 * with generic client-side copy, even to "clean it up."
 */
export function ErrorBanner({ error, onDismiss }: ErrorBannerProps) {
  if (!error) return null;
  const message = error instanceof ApiError ? error.message : error instanceof Error ? error.message : String(error);
  const code = error instanceof ApiError ? error.code : null;

  return (
    <div className="flex items-start justify-between gap-3 border border-[var(--danger)] bg-[var(--danger-bg)] px-3 py-2 text-[12.5px] text-[var(--danger)]">
      <div className="flex flex-col gap-0.5">
        {code && <span className="font-mono text-[10.5px] uppercase tracking-wide opacity-70">{code}</span>}
        <span className="leading-snug">{message}</span>
      </div>
      {onDismiss && (
        <button onClick={onDismiss} aria-label="Dismiss" className="shrink-0 opacity-70 hover:opacity-100">
          ×
        </button>
      )}
    </div>
  );
}
